(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lb-consent"] && !Shopify.designMode) return;
  try {
    (function () {
    var MSG = "Coche la case pour t'inscrire à la newsletter.";
    function err(box) {
      return document.getElementById(box.getAttribute('aria-describedby'));
    }
    function sync(box) {
      box.setCustomValidity(box.checked ? '' : MSG);
      if (box.checked) err(box).hidden = true;
    }
    function init() {
      document.querySelectorAll('[data-lb-consent]').forEach(sync);
    }
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('[data-lb-consent]')) sync(e.target);
    });
    document.addEventListener(
      'invalid',
      function (e) {
        var box = e.target;
        if (!box.matches || !box.matches('[data-lb-consent]')) return;
        box.setAttribute('aria-invalid', 'true');
        err(box).hidden = false;
      },
      true
    );
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
